import { useCallback } from 'react';
import { ColDef } from 'ag-grid-community';

export interface SortConfig {
  field: string;
  direction: 'asc' | 'desc';
}

export interface UseCustomSortingOptions {
  sorting?: SortConfig | null;
  onSortingChange?: (sorting: SortConfig | null) => void;
  columnDefs?: ColDef[];
}

export const useCustomSorting = ({ 
  sorting, 
  onSortingChange, 
  columnDefs = [] 
}: UseCustomSortingOptions) => {
  
  const handleSort = useCallback((field: string) => {
    if (!onSortingChange) return;

    // 🎯 Verificar si la columna es sortable
    const column = columnDefs.find(col => col.field === field);
    if (!column?.sortable) return;

    let newDirection: 'asc' | 'desc' = 'asc';
    
    // Si es el mismo campo, cambiar dirección
    if (sorting?.field === field) {
      newDirection = sorting.direction === 'asc' ? 'desc' : 'asc';
    }

    onSortingChange({ field, direction: newDirection });
  }, [sorting, onSortingChange, columnDefs]);

  const isSortable = useCallback((field?: string) => {
    if (!field || !onSortingChange) return false;
    
    // 🎯 Verificar si la columna tiene sortable: true
    const column = columnDefs.find(col => col.field === field);
    return column?.sortable === true;
  }, [onSortingChange, columnDefs]);

  const getSortDirection = useCallback((field: string): 'up' | 'down' | 'neutral' => {
    if (sorting?.field !== field) return 'neutral';
    
    // 🎯 Lógica invertida: asc = down, desc = up
    return sorting.direction === 'asc' ? 'down' : 'up';
  }, [sorting]);

  return {
    handleSort,
    isSortable,
    getSortDirection,
    currentSort: sorting
  };
};
